// export var xmlStr = `<?xml version="1.0" encoding="UTF-8"?>
// <definitions xmlns="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:omgdi="http://www.omg.org/spec/DD/20100524/DI" xmlns:omgdc="http://www.omg.org/spec/DD/20100524/DC" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" id="sid-38422fae-e03e-43a3-bef4-bd33b32041b2" targetNamespace="http://bpmn.io/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.1.2">
// <process id="Process_1" isExecutable="false">
//     <startEvent id="StartEvent_1y45yut" name="开始1111">
//     <outgoing>SequenceFlow_0h21x7r</outgoing>
//     </startEvent>
//     <task id="Task_1hcentk" name="用户">
//     <incoming>SequenceFlow_0h21x7r</incoming>
//     </task>
//     <sequenceFlow id="SequenceFlow_0h21x7r" sourceRef="StartEvent_1y45yut" targetRef="Task_1hcentk" />
// </process>
// <bpmndi:BPMNDiagram id="BpmnDiagram_1">
//     <bpmndi:BPMNPlane id="BpmnPlane_1" bpmnElement="Process_1">
//     <bpmndi:BPMNShape id="StartEvent_1y45yut_di" bpmnElement="StartEvent_1y45yut">
//         <omgdc:Bounds x="152" y="102" width="36" height="36" />
//         <bpmndi:BPMNLabel>
//         <omgdc:Bounds x="160" y="145" width="22" height="14" />
//         </bpmndi:BPMNLabel>
//     </bpmndi:BPMNShape>
//     <bpmndi:BPMNShape id="Task_1hcentk_di" bpmnElement="Task_1hcentk">
//         <omgdc:Bounds x="240" y="80" width="100" height="80" />
//     </bpmndi:BPMNShape>
//     <bpmndi:BPMNEdge id="SequenceFlow_0h21x7r_di" bpmnElement="SequenceFlow_0h21x7r">
//         <omgdi:waypoint x="188" y="120" />
//         <omgdi:waypoint x="240" y="120" />
//     </bpmndi:BPMNEdge>
//     </bpmndi:BPMNPlane>
// </bpmndi:BPMNDiagram>
// </definitions>`



// export var xmlStr =`<?xml version="1.0" encoding="UTF-8"?>
// <definitions xmlns="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:omgdi="http://www.omg.org/spec/DD/20100524/DI" xmlns:omgdc="http://www.omg.org/spec/DD/20100524/DC" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" id="sid-38422fae-e03e-43a3-bef4-bd33b32041b2" targetNamespace="http://bpmn.io/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.1.2">
//   <process id="Process_1" isExecutable="false">
//     <startEvent id="StartEvent_1y45yut" name="开始1111" personnel="88888" handle="1" selectStatus="">
//       <outgoing>SequenceFlow_1dhxo3c</outgoing>
//     </startEvent>
//     <task id="Task_1hcentk" name="用户2" personnel="6666" handle="2" selectStatus="1" condition="0" variable="var al=6666">
//       <incoming>SequenceFlow_1dhxo3c</incoming>
//     </task>
//     <sequenceFlow id="SequenceFlow_1dhxo3c" sourceRef="StartEvent_1y45yut" targetRef="Task_1hcentk" />
//   </process>
//   <bpmndi:BPMNDiagram id="BpmnDiagram_1">
//     <bpmndi:BPMNPlane id="BpmnPlane_1" bpmnElement="Process_1">
//       <bpmndi:BPMNShape id="StartEvent_1y45yut_di" bpmnElement="StartEvent_1y45yut">
//         <omgdc:Bounds x="372" y="52" width="36" height="36" />
//         <bpmndi:BPMNLabel>
//           <omgdc:Bounds x="368" y="28" width="44" height="14" />
//         </bpmndi:BPMNLabel>
//       </bpmndi:BPMNShape>
//       <bpmndi:BPMNShape id="Task_1hcentk_di" bpmnElement="Task_1hcentk">
//         <omgdc:Bounds x="630" y="150" width="100" height="80" />
//       </bpmndi:BPMNShape>
//       <bpmndi:BPMNEdge id="SequenceFlow_1dhxo3c_di" bpmnElement="SequenceFlow_1dhxo3c">
//         <omgdi:waypoint x="408" y="70" />
//         <omgdi:waypoint x="519" y="70" />
//         <omgdi:waypoint x="519" y="190" />
//         <omgdi:waypoint x="630" y="190" />
//       </bpmndi:BPMNEdge>
//     </bpmndi:BPMNPlane>
//   </bpmndi:BPMNDiagram>
// </definitions>`


export var xmlStr =   `<?xml version="1.0" encoding="UTF-8"?> 
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"  
                  xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL"  
                  xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI"  
                  xmlns:dc="http://www.omg.org/spec/DD/20100524/DC"  
                  targetNamespace="http://bpmn.io/schema/bpmn"
                  id="Definitions_1"> 
  <bpmn:process id="Process_1" isExecutable="true"> 
  </bpmn:process> 
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"> 
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1"> 
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1"> 
        <dc:Bounds height="36.0" width="36.0" x="173.0" y="102.0"/> 
      </bpmndi:BPMNShape> 
    </bpmndi:BPMNPlane> 
  </bpmndi:BPMNDiagram> 
</bpmn:definitions>`